var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bvue-ui-view',{staticClass:"flex flex-col"},[_c('h1',[_vm._v("Paises")]),_vm._v(" "),_c('p',[_vm._v("Pulsa en la fila para editar la conversión.")]),_vm._v(" "),_c('div',{staticClass:"flex-1 overflow-scroll relative"},[_c('sortable-table',{attrs:{"items":_vm.items,"columns":_vm.columns,"startSort":"id"},on:{"rowSelected":_vm.rowSelected}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb89a1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/Countries.vue
// module id = null
// module chunks = 